import axios from "axios";
import {
  getCookie,
  IEventInformation,
  IResponseEvent,
  ISubscribed,
  PostSubscribedType,
  SourceType
} from "../enums";

axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
axios.defaults.timeout = 10000;
axios.defaults.withCredentials = true;
axios.defaults.headers.common["x-topdev-referrer"] = window.location.href;
const token = getCookie(process.env.REACT_APP_TOKEN_NAME || "topdev_token");
const jwtToken = getCookie("topdevcv_token");//HOtfix
const source = document
        .getElementById("modal-event")
        ?.getAttribute("data-source") as SourceType;
const isResumDashPage = () => {
  return (source === "resume-dash")
}

export const fetchEventInformation = (data: IEventInformation) => {
  return axios.get<IResponseEvent>("ev/events", {
    headers: {
      Authorization: "Bearer " + (isResumDashPage() ? jwtToken : token),
      "x-topdev-source": data.source || "",
      // "x-topdev-referrer": window.location.href,
    },
  });
};

export const fetchSubscribed = (data: PostSubscribedType) => {
  return axios.post<ISubscribed>(
    "ev/users/me/subscribed-events",
    {
      ...data,
    },
    { headers: { Authorization: "Bearer " + (isResumDashPage() ? jwtToken : token) } }
  );
};
